export default __webpack_public_path__ + "static/media/MyKaizen.05deb53bd549cd4932807ef70b4f92a4.webp";